import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { faArrowLeft } from "@fortawesome/fontawesome-free-solid";
import Footer from "../components/footer/Footer";
import { VscDebugBreakpointLog } from "react-icons/vsc";
import PrivacyPolicy from "./PrivacyPolicy";
// import { faSquareCheck, faCheck } from "@fortawesome/free-solid-svg-icons";

const CookiePolicy = () => {
  return (
    <div className="bg-black pb-20">
      {/* header */}
      <Navbar />

      <div className="mt-14 px-5 sm:px-10 xl:px-16 2xl:px-32 w-min text-white">
        <Link
          to="/login"
          className="bg-slate-900 border border-slate-800 rounded-full p-2"
        >
          <FontAwesomeIcon
            icon={faArrowLeft}
            className="w-5 h-5 text-white/800 cursor-pointer pt-0.5"
          />
        </Link>
      </div>

      <div className="cardBorder1 borderFN mx-3 xs:mx-5 sm:mx-10 xl:mx-16 2xl:mx-32 mt-5 font-body ">
        <div id="grad" className="rounded-lg">
          <div className="font-body">
            <div className="bg-gradient-to-r from-[#0c0c0c] via-[#444444] to-[#0c0c0c] rounded-t-xl">
              <h2 className="text-white text-xl text-left px-5 lg:px-10 py-2.5">
                Cookie Policy
              </h2>
            </div>
            <h2 className="font-body text-lg sm:text-xl md:text-2xl lg:text-3xl font-normal text-center text-slate-100 px-5 md:px-20 xl:px-44 py-10 leading-10">
              This Cookie Policy (“Notice”) gives complete details of how the
              cookies are used when you are visiting domains managed by
              Tracklimo.
            </h2>
            <h2 className="font-body text-xl lg:text-2xl font-semibold text-white pb-5 text-center">
              Please note that this Notice is part of our
              <Link
                to="../PrivacyPolicy"
                className="text-blue-500 hover:underline ml-1.5"
              >
                Privacy Policy
              </Link>
              .
            </h2>
            <div className="px-5 lg:px-10 text-slate-100">
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-6">
                I. What is a cookie?
              </h2>
              <h2 className="font-body py-1 text-white">
                A cookie is a small text file placed on your device (computer,
                mobile phone, etc.) by the websites that you visit in order to
                remember information about you and your preferences. Cookies
                make the website work more efficiently and can be used for the
                provision of more personalized services. The expression
                “cookies” can refer to browser cookies as well as a number of
                similar technologies including tracking pixels/web beacons,
                local shared objects/flash cookies and sensors, which provide
                access to device information.
              </h2>

              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                II. What types of cookies do we use?
              </h2>
              <h2 className="font-body py-1">
                There are two broad{" "}
                <span className="text-blue-500 font-semibold">categories</span>{" "}
                of cookies what we are using.{" "}
                <span className="text-blue-500 font-semibold">
                  First party cookies
                </span>
                , served directly by us to your device or{" "}
                <span className="text-blue-500 font-semibold">
                  Third-party cookies
                </span>
                , set by other entities or providers on our behalf.
                <br />
                <br />
                Our domains use the following{" "}
                <span className="text-blue-500 font-semibold">types</span> of
                First party- and Third-party cookies:
              </h2>

              <div className="ml-10">
                <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                  1. Strictly necessary (essential cookies):
                </h2>
                <h2 className="font-body py-1">
                  These cookies are essential for running our web sites and are
                  the key to providing you a seamless experience. For that
                  reason, these cookies are set by default as always active
                  cookies, and we do not request your consent to use them.
                  However, you can set your browser to block or alert you about
                  these cookies, but some parts of the sites will not work
                  then. These cookies are used e.g., to remember products of
                  interest when you are redirected to a payment site for a
                  possible purchase.
                </h2>
                <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                  2. Functional cookies:
                </h2>
                <h2 className="font-body py-1">
                  These cookies help make the content as personalized as
                  possible, for example by showing you targeted banners and
                  relevant recommendations (e.g.: functionality cookies can be
                  used to store search results and language and to enable
                  personalization).
                </h2>
                <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                  3. Analytical and performance cookies:
                </h2>

                <h2 className="font-body py-1">
                  These cookies enable us to improve our websites and business
                  processes by looking at how our websites are used. We use
                  these cookies to understand e.g., unique users reading a
                  particular article (to know what is popular), if a video file
                  was viewed or abandoned half way through, or the effectiveness
                  of our recruitment campaigns. We also look at where the
                  content is accessed from so, we know how to arrange our sites
                  for optimal user experience. These cookies do not collect
                  information that could identify you.
                </h2>
                <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                  4. Advertising and targeting cookies:
                </h2>

                <h2 className="font-body py-1">
                  We use these cookies to dynamically serve TRACKLIMO ads on
                  both TRACKLIMO websites and selected third party websites. Our
                  domains may also include elements that set cookies on behalf
                  of a third party, e.g., a “Like”-button from Facebook or a
                  “Tweet”-button from Twitter.
                </h2>
              </div>
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                III. How long will cookies remain on your device?
              </h2>

              <h2 className="font-body py-1">
                Cookies can remain on your device for different periods of time,
                depend on whether it is a{" "}
                <span className="text-blue-500 font-semibold">“Session”</span>{" "}
                or{" "}
                <span className="text-blue-500 font-semibold">
                  “Persistent”
                </span>{" "}
                cookie. A session cookie will expire at the end of your web
                session, when the browser is closed. A persistent cookie will be
                stored by a browser and will remain valid until its set
                expiration date, unless deleted by you before the expiration
                date via cookie manager or via changing the cookie setting in
                your browser.
              </h2>

              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                IV. How can you control cookies?
              </h2>
              <h2 className="font-body py-1">
                You can manage cookies in several ways. Please keep in mind,
                that disabling cookies may prevent you from using certain parts
                of TRACKLIMO websites. If you delete your cookies from the
                browser, you may need to remember to re-install opt-out cookies
                and re-select your preferences in the cookie management tools
                provided on TRACKLIMO websites.
                <br />
                <br />
                You can review the options available to manage cookies in your
                browser. The browser can be used to manage cookies relating to 
                <span className="text-blue-500 font-semibold">
                  all types of cookies
                </span>
                . Different browsers use different ways to disable cookies. The
                support documents on how to manage and delete cookies from the
                major web browsers are available on browser’s official support
                documents: <br />
                - Chrome
                <br /> - Safari
                <br /> - Firefox
                <br /> - Internet Explorer
                <br />
                <br />
                You may also use cookie management tools provided on TRACKLIMO
                websites to manage cookies. Depending on where you are accessing
                the TRACKLIMO websites from, these tools may appear when you
                first visit a TRACKLIMO website. They are also available through
                a link in the website footer.
              </h2>

              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                Legal title
              </h2>
              <h2 className="font-body py-1">
                Where cookies are not strictly necessary for the provision of
                our domains, we will ask you to consent to our use of cookies
                when you first visit the domain by clicking on “Manage cookie
                preferences” at the top of this page.
              </h2>
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                V. What cookies do we use?
              </h2>
              <h2 className="font-body py-1">
                The list on below mentioned link includes use of cookies placed
                or managed by TRACKLIMO or by independent third parties. Since
                the number and names of cookies, pixels and other technologies
                may change, this list may be updated from time to time. You
                should revisit this list from time to time to identify relevant
                updates. This list is also directly available within the cookie
                management tool.
                <br />
                <br />
                Please note we may use content of 3rd parties who are data
                controllers using their own cookies, we recommend you check the
                privacy policy of these parties:
                <br />
                - Microsoft
                <br />
                - Meta <br />- Youtube
              </h2>

              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                Controller’s contact information
              </h2>
              <h2 className="font-body py-1">
                If you have questions, requests, or concerns regarding your
                privacy and rights, please let us know how we can help.
              </h2>

              <div className="ml-10 pb-16">
                <h2 className="font-body py-1">
                  <br />
                  Data Protection Officer
                  <br />
                  <br />
                  Drivado Transfers Pvt Ltd
                  <br />
                  c/o Privacy
                  <br />
                  P-3 New CIT Road <br />
                  4th Floor, Kolkata 700073
                  <br />
                  India
                  <br />
                  <br />
                  Email:{" "}
                  <a href="mailto:support@drivado.com">support@drivado.com</a>
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-5 sm:px-10 xl:px-16 2xl:px-32">
        <Footer />
      </div>
    </div>
  );
};

export default CookiePolicy;
